import axios from '@/jslib/axios'

// Endorsements Waiting Purchase
export const getPolicyModifyList = params => {
  return axios({
    method: 'get',
    url: '/admin/policy/modify/list',
    params
  })
}